import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './unAuth/Components/nav bar';
import Home from './pages/Home';
import News from './pages/News';
import Assets from './pages/Assets';
import Team from './pages/Team';
import Tokenization from './pages/Tokenization';
import Article from './pages/Article';
import Admin from './pages/Admin';
import Legal from './pages/Legal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PrivacyRequests from './pages/PrivacyRequests';
import LeadForm from './unAuth/Components/lead form';
import ScrollToTop from './components/ScrollToTop';
import { ConsentProvider } from './contexts/ConsentContext';
import CookieBanner from './components/CookieBanner';
import CookieSettings from './components/CookieSettings';

function App() {
  const [isLeadFormOpen, setIsLeadFormOpen] = useState(false);

  const openLeadForm = () => {
    setIsLeadFormOpen(true);
  };

  return (
    <ConsentProvider>
      <Router>
        <ScrollToTop />
        <NavBar onLearnMore={openLeadForm} />
        <div style={{ paddingTop: '80px' }}>
          <Routes>
            <Route path="/" element={<Home onLearnMore={openLeadForm} />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<Article />} />
            <Route path="/properties" element={<Navigate to="/assets" replace />} />
            <Route path="/assets" element={<Assets onLearnMore={openLeadForm} />} />
            <Route path="/team" element={<Team onLearnMore={openLeadForm} />} />
            <Route path="/tokenization" element={<Tokenization onLearnMore={openLeadForm} />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy-requests" element={<PrivacyRequests />} />
          </Routes>
        </div>
        <LeadForm isOpen={isLeadFormOpen} onClose={() => setIsLeadFormOpen(false)} />
        <CookieBanner />
        <CookieSettings />
      </Router>
    </ConsentProvider>
  );
}

export default App;
